import type { RouteObject } from 'react-router-dom';

import { RequireSection } from '@/shared/routing';

import { ChannelStockPage } from './ui/pages/ChannelStockPage';

/**
 * Channel-availability configuration feature (plan-platform-001 WP2.3b,
 * design-stock-channels-page §5): a single flat route with in-page tabs synced to `?tab=`.
 */
export const channelStockRoutes: RouteObject = {
  path: 'channels/stock',
  element: (
    <RequireSection section="channelStock">
      <ChannelStockPage />
    </RequireSection>
  ),
};
